<template>
  <div>
    <roles-menu></roles-menu>

    <v-row class="mb-3">
      <v-col cols="3">
        <v-text-field :label="$t('global.search')" append-icon="search" hide-details single-line v-model="search"></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <div>
        <v-btn block color="accent" to="/settings/role/new">{{ $t("settings.role.addNewRole") }}</v-btn>
      </div>
    </v-row>

    <v-data-table :headers="headers" :items="roleList" :search="search">
      <template #item="props">
        <tr>
          <td class="text-left">{{ props.item.name }}</td>
          <td class="text-left">{{ props.item.description }}</td>
          <td class="text-left">
            {{ props.item.count_permissions }} /
            {{ props.item.count_parent_roles }}
          </td>
          <td class="text-left">{{ props.item.count_users }} ({{ props.item.count_temp_users }})</td>
          <td class="text-center text-no-wrap">
            <v-tooltip bottom>
              {{ $t("settings.role.assignUsers") }}
              <template #activator="{on}">
                <v-btn :to="'/settings/role/edit-users/' + encodeURIComponent(props.item.name)" icon v-on="on">
                  <v-icon>people</v-icon>
                </v-btn>
              </template>
            </v-tooltip>

            <v-tooltip bottom>
              <template #activator="{on}">
                <v-btn :to="'/settings/role/edit/' + encodeURIComponent(props.item.name)" icon v-on="on">
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>
              {{ $t("global.edit") }}
            </v-tooltip>

            <v-tooltip bottom>
              <template #activator="{on}">
                <v-btn :disabled="!canBeDeleted(props.item) || $store.getters['Ajax/loading']" @click="remove(props.item)" icon v-on="on">
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
              <span v-if="!canBeDeleted(props.item)">{{ $t("settings.role.detachUsersFirst") }}</span>
              <span v-else>{{ $t("global.delete") }}</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import RolesMenu from "../../../components/Settings/RolesMenu.vue";

export default {
  name: "SettingsRoleView",
  components: { RolesMenu },
  data: () => ({
    groupList: [],
    search: null,
    roleList: []
  }),
  computed: {
    headers() {
      return [
        { text: this.$t("global.name"), value: "name" },
        { text: this.$t("global.description"), value: "description" },
        {
          text: this.$t("settings.role.parentPermissionsRoles"),
          value: "count_permissions"
        },
        { text: this.$t("settings.role.usersCount"), value: "count_users" },
        { text: this.$t("global.actions"), sortable: false, value: "actions", align: "center" }
      ];
    }
  },
  created() {
    this.axios.get("settings/auth-admin/list-roles").then(resp => {
      this.roleList = resp.data;
    });
  },
  methods: {
    canBeDeleted(item) {
      return item.count_users === 0 && item.count_temp_users === 0 && item.count_parent_roles === 0;
    },
    remove(item) {
      this.axios.post("settings/auth-admin/delete-role", { name: item.name }).then(() => {
        this.axios.get("settings/auth-admin/list-roles").then(resp => {
          this.roleList = resp.data;
          this.$store.dispatch("snackbarPush", {
            text: this.$t("settings.role.removedRole"),
            color: "error",
            position: "down"
          });
        });
      });
    }
  }
};
</script>

<style></style>
